module.exports = __webpack_public_path__ + "img/colorbar.9fb0110f.png";